// extracted by mini-css-extract-plugin
export default {"main":"styles_main__7Xfxr","img":"styles_img__Cy1-+","data":"styles_data__5pwdZ"};